

//const BaseUrl = "https://sas.hkcl.net";
// const BaseUrl = "http://localhost:8081";
//const BaseUrl = "https://sastest.hkcl.net";
const BaseUrl = "https://sainikwelfareharyana.gov.in";

export default BaseUrl;